import { useEffect } from 'react';

import { LanguageProvider as LanguageProviderBase } from '@spazious/dollhouse-i18n';
import * as locales from '@spazious/dollhouse-locales';
import { useStore } from '@spazious/dollhouse-store';
import { UnitType } from '@spazious/dollhouse-types';

export interface LanguageProviderProps {
  children: React.ReactNode;
}

/**
 * Custom LanguageProvider component that uses the default language from the store
 */
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const defaultLanguage = useStore(({ language }) => language);
  const set = useStore(({ set }) => set);

  useEffect(() => {
    // Keep units aligned with persisted language (locale can include region, e.g. en-US).
    const locale = `${defaultLanguage ?? ''}`.toUpperCase();
    const imperialRegions = ['-US', '-LR', '-MM'];
    const nextUnit = imperialRegions.some((region) => locale.endsWith(region))
      ? UnitType.Feet
      : UnitType.Meter;
    set({ measurementsUnit: nextUnit });
  }, [defaultLanguage, set]);

  return (
    <LanguageProviderBase defaultLocale={defaultLanguage} locales={locales}>
      {children}
    </LanguageProviderBase>
  );
};
